"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APOLLO_OVERWRITE = 'APOLLO_OVERWRITE';
exports.APOLLO_RESET = 'APOLLO_RESET';
exports.APOLLO_WRITE = 'APOLLO_WRITE';
//# sourceMappingURL=constants.js.map